<form>
  <xena-table  sticky-header>
      <xena-column width="40%"  i18n="@@import_csv_imported_project_number">Imported project number</xena-column>
      <xena-column width="60%" i18n="@@import_csv_xena_order_task">Xena order task</xena-column>
      <xena-row *ngFor="let mapping of orderTaskMappings.controls" [formGroup]="mapping">
        <xena-cell title="{{mapping.get('projectName').value}}" class="truncate">{{ mapping.get('projectNumber').value +' '+ mapping.get('projectName').value}}</xena-cell>
        <xena-cell>
          <xena-autocomplete
            [datasource]="orderTaskDatasource"
            formControlName="orderTask"
            [listLabelProperty]="orderTaskNumber"
            [valueLabelProperty]="orderTaskNumber"
            [listIconProperty]="orderTaskIcon"
            debounce="300"
            show-initial-no-result="false"
            no-result-text="No results"
            i18n-no-result-text="@@import_csv_order_task_noResult" hoist>
            <span slot="error-text" *ngIf="mapping.touched && mapping.invalid" i18n="@@import_csv_order_task_required">Order task required</span>
          </xena-autocomplete>
        </xena-cell>
      </xena-row>
  </xena-table>
</form>
